export const membershipNotificationsQueryKeys = {
  notifications: () => ['notifications']
}
